module.exports = __webpack_public_path__ + "img/airteltigo-money-logo.12897f4d.png";